import { RegisterEffects } from './register.effect';

export const effects: any[] = [RegisterEffects];

export * from './register.effect';
